// eslint-disable-next-line
export const limitlessAiConstants = {
  LIMITLESS_AI_ACTIVATE: 'LIMITLESS_AI_ACTIVATE',
  LIMITLESS_AI_DEACTIVATE: 'LIMITLESS_AI_DEACTIVATE',
  LIMITLESS_AI_SET_TRAY_OPEN: 'LIMITLESS_AI_SET_TRAY_OPEN',
  LIMITLESS_AI_UPDATE_CONTEXT: 'LIMITLESS_AI_UPDATE_CONTEXT',
  LIMITLESS_AI_REQUEST_ACTION: 'LIMITLESS_AI_REQUEST_ACTION',
  LIMITLESS_AI_CLEAR_PENDING_ACTION: 'LIMITLESS_AI_CLEAR_PENDING_ACTION',
  LIMITLESS_AI_SET_DISPLAY_NAME: 'LIMITLESS_AI_SET_DISPLAY_NAME',
  LIMITLESS_AI_RESET_DISPLAY_NAME: 'LIMITLESS_AI_RESET_DISPLAY_NAME',
};
